import { IDateOfLoss, isDateOfLossValid } from './dateOfLossRules';

export interface IIsCustomerAllowedToSelectWorkshopInput {
    isPrivateCustomer: boolean;
    isCommercialUser: boolean;

    // 'personbil' (car)
    // 'varevogn' (van)
    // 'knallert' (motorbike)
    // 'trailer' (trailer)
    // 'campingvgn' (caravan) NOTE: is misspelled intentionally in Danish, as this is the actual value expected by the backend
    // 'others'
    vehicleType: string;

    hasLicenseplate: boolean;
    isDamangeOnCustomersVehicle: boolean;

    dateOfLoss: IDateOfLoss;
}

const _validVehicleTypes = ['personbil', 'varevogn'];

export const isCustomerAllowedToSelectWorkshop = (
    input: IIsCustomerAllowedToSelectWorkshopInput,
    customerType: 'cpr' | 'cvr'
): boolean => {
    const generalRules =
        _validVehicleTypes.includes(input.vehicleType) &&
        input.hasLicenseplate &&
        input.isDamangeOnCustomersVehicle &&
        isDateOfLossValid(input.dateOfLoss);

    if (customerType === 'cpr') {
        return input.isPrivateCustomer && generalRules;
    }

    if (customerType === 'cvr') {
        return input.isCommercialUser && generalRules;
    }

    return false;
};
